const MB = bytes => bytes / 1e6
const textDecoder = new TextDecoder('utf-8')

const defaultHandler = arrayBuffers => {
  // Calculer la taille totale des données
  let totalLength = 0;
  for (let i = 0; i < arrayBuffers.length; i++) {
    totalLength += arrayBuffers[i].byteLength;
  }

  // Créer un nouvel ArrayBuffer de la taille totale
  const concatenatedBuffer = new ArrayBuffer(totalLength);

  // Créer une vue Uint8Array pour copier les données
  const concatenatedView = new Uint8Array(concatenatedBuffer);

  // Copier les données de chaque ArrayBuffer dans le nouvel ArrayBuffer
  let offset = 0;
  for (let i = 0; i < arrayBuffers.length; i++) {
    const sourceView = new Uint8Array(arrayBuffers[i]);
    concatenatedView.set(sourceView, offset);
    offset += sourceView.length;
  }

  return JSON.parse(textDecoder.decode(concatenatedView))
}

async function streamData(socket, stream, options = {}) {
  try {
    const { streamId, packetIds, streamedBytes } = stream
    const { tracker = null, handler = defaultHandler, timeout = null } = options

    if (packetIds.length === 1) {
      /**
       * Case 1 : data is sent in one chunk
       */
      if (globalThis.debugWorkspace) console.log(`Stream ${streamId}: received ${MB(streamedBytes).toFixed(2)} MB in one chunk`)
      return handler(packetIds)
    } else {
      /**
       * Case 2 : data is sent in multiple chuncks
       */
      let downloadedBytes = 0
      let streamTimeout = !timeout ? null : setTimeout(() => {
        throw Error(`Stream ${streamId} timed out after ${timeout} ms (${MB(downloadedBytes)} MB downloaded)`)
      }, timeout)

      if (globalThis.debugWorkspace) console.log(`Stream ${streamId}: receiving ${MB(streamedBytes).toFixed(2)} MB in ${packetIds.length} chunks`)

      const start = Date.now()
      let chunksArray = []
      for (let packetId of packetIds) {
        await socket.request("stream.getPacket", packetId).then(packet => {
          if (packet.packetId !== packetId) throw Error(`Bad stream data packet`)
          if (globalThis.debugWorkspace) console.log(`stream ${streamId}: packet ${packet.chunkNum}/${packetIds.length} ${packetId} fetched`)
          downloadedBytes += packet.chunk.byteLength
          if (tracker) tracker(downloadedBytes, streamedBytes, packet)
          chunksArray.push(packet.chunk)
        })
      }
      const ms = Date.now() - start
      clearTimeout(streamTimeout)
      if (globalThis.debugWorkspace) console.log(`Stream ${streamId}: finished in ${ms.toFixed(0)} ms at ${(1000 * MB(downloadedBytes) / ms).toFixed(2)} MB/s`)
      return handler(chunksArray)
    }
  } catch (err) {
    console.log(`Stream error ${err.message}`, stream)
    return null
  }
}

function waitForStream(socket, streamUid, options) {
  if (globalThis.debugWorkspace) console.log(`Waiting for stream ${streamUid} ...`)
  return new Promise((resolve, reject) => socket.once(streamUid, stream => streamData(global.socket, stream, options)
    .then(state => resolve(state))
    .catch(err => reject(err)),
    options)
  )
}

module.exports = { waitForStream, streamData, defaultHandler }